// The site is served as pure static HTML/CSS/JS from /app/frontend/public.
// React is intentionally kept as a no-op so the static content renders as-is.
function App() {
  return null;
}

export default App;
